// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2KzrI","title":"ClientInsurance_title__2o4dl","itemText":"ClientInsurance_itemText__2aUnD"};